<template>
  <material-chart-card color="white" elevation="0" type="Line" :data="chartData" :options="options">
    <v-layout>
      <v-flex>
        <div class="headline font-weight-light mb-1">Liczba kart</div>

        <div class="category d-inline-flex font-weight-light mr-2">Dzienna liczba aktywowanych kart</div>
      </v-flex>
    </v-layout>

    <template slot="actions">
      <v-layout>
        <v-flex> <v-icon class="mr-2" small>mdi-calendar</v-icon>Ostatni tydzień </v-flex>
      </v-layout>
    </template>
  </material-chart-card>
</template>

<script>
import MaterialChartCard from '@/components/material/ChartCard';
import { chartMixin } from '@/mixins/chart';

// @vuese
// Wykres z liczbą aktywowanych kart
// @group Chart
export default {
  components: { MaterialChartCard },
  mixins: [chartMixin],
  props: {
    // opcje wykresu
    chartOptions: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      options: {
        lineSmooth: this.$chartist.Interpolation.cardinal({
          tension: 0,
          fillHoles: true
        }),
        axisY: {
          onlyInteger: true
        },
        low: 0,
        chartPadding: {
          top: 27,
          right: 15,
          bottom: 0,
          left: 0
        },
        ...this.chartOptions
      },
      chartData: this.generateChartData(this.$store.state.stats.activatedCards)
    };
  }
};
</script>
